import { translateKey } from '@frontend/translate';
import type { ICustomControlDiagnosticReportReadProps } from '../../interfaces/customControlDiagnosticReportReadProps';
import { FormGroupRead } from '../../utils/v1/FormGroupRead';

export function TcohV2DiagnosticReportSummary(props: ICustomControlDiagnosticReportReadProps) {
    const customControlData = props.diagnosticReport.customControlData;

    return (
        <>
            <FormGroupRead
                label={translateKey('common.conclusion')}
                value={customControlData.conclusie}
            />

            <FormGroupRead
                label={translateKey('diagnosticReport.advice')}
                value={customControlData.advies}
            />
        </>
    );
}
